import React, { useState } from "react";

const faqData = [
  {
    question: "Is MCC registration required for AIIMS or JIPMER?",
    answer: (
      <p>
        Yes. All AIIMS and JIPMER seats are filled through MCC counselling under
        the 15% All India Quota (AIQ) and central university counselling
        process.
      </p>
    ),
  },
  {
    question: "Can I participate in both AIQ and state counselling?",
    answer: (
      <p>
        Yes. You are eligible to participate in both MCC AIQ counselling and
        your state’s counselling. However, you must follow the rules, timelines,
        and reporting guidelines of each separately.
      </p>
    ),
  },
  {
    question: "What is the Free Exit option?",
    answer: (
      <p>
        If you are allotted a seat in Round 1 of MCC counselling and don’t
        report or join, there is no penalty. This is called Free Exit.
      </p>
    ),
  },
  {
    question: "What happens if I don’t join after Round 2?",
    answer: (
      <p>
        If you are allotted a seat in Round 2 and do not join, your security
        deposit is forfeited, and you become ineligible for further rounds.
      </p>
    ),
  },
  {
    question: "What is the difference between Mop-Up and Stray Vacancy Rounds?",
    answer: (
      <p>
        Mop-Up Round is conducted by MCC to fill seats left after Round 2. Fresh
        registration may be allowed. Stray Vacancy Round is the final round,
        where leftover seats are filled by colleges based on merit from the list
        of registered candidates. No fresh registration is permitted in the
        stray round.
      </p>
    ),
  },
  {
    question: "Can I apply for both AIQ and Deemed University counselling?",
    answer: (
      <p>
        Yes. You can apply for both simultaneously. You only need to pay the
        higher registration fee, i.e., the fee applicable for Deemed University
        seats.
      </p>
    ),
  },
  {
    question: "When is the security deposit forfeited?",
    answer: (
      <p>
        It is forfeited if you don’t join the allotted seat in Round 2 or Mop-Up
        Round, or if your seat is cancelled due to false or incomplete
        documents.
      </p>
    ),
  },
  {
    question:
      "Can I participate in the Mop-Up Round if I didn't register earlier?",
    answer: (
      <p>
        No. Only candidates who have registered during the counselling process
        and have not been allotted/admitted in previous rounds are eligible for
        the Mop-Up Round. Fresh registrations are not allowed unless specified.
      </p>
    ),
  },
  {
    question: "Are there any MBBS colleges exclusively for girls?",
    answer: (
      <p>
        Yes. A few medical colleges admit only female candidates, such as Lady
        Hardinge Medical College (Delhi), BPS Government Medical College
        (Sonipat), Sri Padmavati Medical College for Women (Tirupati), and
        Symbiosis Medical College for Women (Pune).
      </p>
    ),
  },
  {
    question: "Are vacant AIQ seats after Round 2 transferred to states?",
    answer: (
      <p>
        No. As per revised rules, MCC conducts four rounds of counselling
        including the Stray Vacancy Round. AIQ seats no longer revert to states
        after Round 2.
      </p>
    ),
  },
];

const NeetCounsellingContent = () => {
  const [activeFAQ, setActiveFAQ] = useState(null);

  const toggleFAQ = (index) => {
    setActiveFAQ(activeFAQ === index ? null : index);
  };

  return (
    <div className="neet-counselling-content w-full max-w-6xl mx-auto p-6 font-sans">
      <h2 className="text-3xl font-bold text-center mb-6">
        NEET Counselling Guidance <span className="text-[#ff9245]">(2026)</span>
      </h2>

      <h2 className="text-2xl font-semibold mt-8">What is NEET Counselling?</h2>
      <p className="mt-4 text-[16px]">
        NEET Counselling is the centralized admission process for students who
        have qualified in NEET (UG) 2026, enabling them to secure seats in MBBS,
        BDS, BAMS, BSMS, BUMS, BHMS, and B.Sc. Nursing courses in India. This
        process involves allocation of seats based on:
      </p>
      <ul className="list-disc list-inside mt-4 pl-6 space-y-2">
        <li>NEET All India Rank (AIR)</li>
        <li>Category of the candidate (UR, SC, ST, OBC, EWS, PwBD)</li>
        <li>Seat availability under different quotas</li>
        <li>
          Preference of colleges and courses filled during counselling
          registration
        </li>
      </ul>
      <p className="mt-4 text-[16px]">
        Counselling ensures that admissions are merit-based, transparent, and
        conducted uniformly across states and institutions.
      </p>

      <h3 className="text-xl font-semibold mt-8">Types of NEET Counselling</h3>
      <p className="mt-4 text-[16px]">There are two major levels of counselling:</p>
      <ol className="list-disc list-inside mt-4 space-y-4">
        <li>
          <b>All India Quota (AIQ) Counselling</b>
          <ul className="list-disc list-inside mt-2 pl-6 space-y-2">
            <p className="text-[16px]">
              <b>Conducted by:</b> Medical Counselling Committee (MCC) under the Directorate General of Health Services (DGHS)
            </p>
            <p className="text-[16px]">
              <b>Includes:</b></p>
            <ul className="list-disc list-inside mt-2 pl-6 space-y-2">
              <li>15% of seats in all Government Medical and Dental Colleges across India (excluding J&amp;K unless they opt in)</li>
              <li>
                100% seats in Central Institutions, including:
                <ul className="list-disc list-inside mt-2 pl-6 space-y-2">
                  <li>AIIMS (All campuses)</li>
                  <li>JIPMER (Puducherry &amp; Karaikal)</li>
                  <li>Banaras Hindu University (BHU)</li>
                  <li>Aligarh Muslim University (AMU)</li>
                  <li>Deemed Universities</li>
                  <li>ESIC Medical Colleges</li>
                  <li>AFMC (Armed Forces Medical College), Pune</li>
                  <li>VMMC &amp; Safdarjung Hospital</li>
                  <li>ABVIMS &amp; RML Hospital</li>
                </ul>
              </li>
            </ul>

            <p className="mt-4 text-[16px]">
              <b>Counselling Rounds:</b></p>
            <ul className="list-disc list-inside mt-2 pl-6 space-y-2">
              <li>Round 1</li>
              <li>Round 2</li>
              <li>Mop-Up Round</li>
              <li>Stray Vacancy Round (for Deemed Universities)</li>
            </ul>

          </ul>
        </li>
        <li>
          <b>State Quota Counselling</b>
          <ul className="list-disc list-inside mt-2 pl-6 space-y-2">
            <p className="text-[16px]">
              <b>Conducted by:</b> Respective State/UT Counselling Authorities
            </p>
            <p className="text-[16px]">
              <b>Includes:</b>
            </p>
            <ul className="list-disc list-inside mt-2 pl-6 space-y-2">
              <li>85% of seats in Government Medical/Dental Colleges in each state/UT</li>
              <li>
                100% of seats in Private Medical and Dental Colleges, including:
                <ul className="list-disc list-inside mt-2 pl-6 space-y-2">
                  <li>State Quota</li>
                  <li>Management Quota</li>
                  <li>NRI Quota</li>
                </ul>
              </li>
            </ul>

            <p className="text-[16px]">Each state publishes its own counselling notification, eligibility rules (domicile/reservation), and application schedule.</p>
            <p className="text-[16px]">State-level merit lists are prepared from NEET AIR by state authorities.</p>
          </ul>
        </li>
        <li>
          <b>AYUSH Counselling (BAMS, BSMS, BUMS, BHMS)</b>
          <ul className="list-disc list-inside mt-2 pl-6 space-y-2">
            <b>Conducted by:</b>
            <ul className="list-disc list-inside mt-2 pl-6 space-y-2">
              <li>
                AACCC (All India AYUSH Counselling Committee) – For 15% AIQ seats (
                <a
                  href="https://aaccc.gov.in"
                  target="_blank"
                  rel="noopener noreferrer nofollow"
                  className="text-blue-500 underline"
                >
                  https://aaccc.gov.in
                </a>
                )
              </li>
              <li>State AYUSH Counselling Authorities – For 85% State Quota and Private AYUSH colleges</li>
            </ul>
          </ul>
        </li>
      </ol>

      <h3 className="text-xl font-semibold mt-8">
        Courses Covered in NEET Counselling
      </h3>
      <ul className="list-disc list-inside mt-4 pl-6 space-y-2">
        <li>MBBS – Bachelor of Medicine and Bachelor of Surgery</li>
        <li>BDS – Bachelor of Dental Surgery</li>
        <li>BAMS – Ayurveda</li>
        <li>BSMS – Siddha</li>
        <li>BUMS – Unani</li>
        <li>BHMS – Homeopathy</li>
        <li>B.Sc. Nursing – Armed Forces Nursing Colleges only</li>
      </ul>

      <h4 className="text-[16px] font-semibold mt-8">Notes:</h4>
      <ul className="list-disc list-inside mt-4 pl-6 space-y-2">
        <li>
          <b>AFMC, Pune:</b> NEET score is used for shortlisting, but admission also includes a second-stage screening conducted by AFMC. Candidates must register on MCC and also apply separately at:{" "}
          <a
            href="https://afmc.nic.in"
            target="_blank"
            rel="noopener noreferrer nofollow"
            className="text-blue-500 underline"
          >
            https://afmc.nic.in
          </a>
        </li>
        <li>
          <b>B.Sc. Nursing (Armed Forces):</b> NEET score is mandatory for admission in AFMS institutions offering nursing programs.
        </li>
        <li>
          <b>NTA’s Role:</b> NTA conducts the NEET (UG) examination, declares the result and All India Rank, and provides the data to MCC and States. It does NOT conduct counselling.
        </li>
        <li>
          <b>J&amp;K &amp; Ladakh:</b> Candidates from J&amp;K and Ladakh are eligible for AIQ from 2026 onwards (unless opted out by state).
        </li>
        <li>
          <b>Counselling Eligibility:</b> During counselling, uploaded documents, eligibility, and category claims will be verified by the respective counselling authorities.
        </li>
      </ul>
      <p className="mt-4 text-[16px]">
        <b>Final Admission Depends On:</b>
      </p>
      <ul className="list-disc list-inside mt-4 pl-6 space-y-2">
        <li>Your NEET AIR</li>
        <li>Your category</li>
        <li>Your choice-filling</li>
        <li>Seat availability in respective colleges</li>
        <li>Reservation and eligibility rules of the respective counselling body (MCC or State)</li>
      </ul>

      <hr className="my-8 border-gray-500" />

      <h2 className="text-2xl font-semibold mt-8">NEET 2026 Counselling Authorities Explained</h2>
      <p className="mt-4 text-[16px]">
        NEET UG 2026 counselling is conducted by two types of authorities based on the nature of the seat and institution.
      </p>
      <ol className="list-decimal list-inside mt-4 space-y-4">
        <li>
          <b>MCC Counselling (Medical Counselling Committee)</b>
          <ul className="list-disc list-inside mt-2 pl-6 space-y-2">
            <p className="text-[16px]">
              <b>Conducted by:</b> DGHS (Directorate General of Health Services) under the Ministry of Health and Family Welfare
            </p>
            <p className="text-[16px]">
              <b>Official website:</b>{" "}
              <a
                href="https://mcc.nic.in"
                target="_blank"
                rel="noopener noreferrer nofollow"
                className="text-blue-500 underline"
              >
                https://mcc.nic.in
              </a>
            </p>
            <p className="text-[16px]">
              <b>Seats Handled by MCC:</b>
            </p>
            <ul className="list-disc list-inside mt-2 pl-6 space-y-2">
              <li>15% All India Quota (AIQ) seats in Government Medical/Dental Colleges (excluding Jammu &amp; Kashmir unless opted in)</li>
              <li>
                100% seats in Central Institutions/Universities:
                <ul className="list-disc list-inside mt-2 pl-6 space-y-2">
                  <li>Delhi University (DU)</li>
                  <li>Banaras Hindu University (BHU)</li>
                  <li>Aligarh Muslim University (AMU)</li>
                </ul>
              </li>
              <li>100% seats in AIIMS and JIPMER (All campuses)</li>
              <li>100% seats in Deemed Universities</li>
              <li>ESIC Medical Colleges (Insured Persons Quota)</li>
              <li>AFMC Pune (Only registration done by MCC; admission managed separately by AFMC)</li>
            </ul>
            <p className="text-[16px]">
              <b>Important:</b>
            </p>
            <ul className="list-disc list-inside mt-2 pl-6 space-y-2">
              <li>Candidates must register separately on the MCC portal.</li>
              <li>AFMC selection includes a second screening test conducted by AFMC itself.</li>
            </ul>
          </ul>
        </li>
        <li>
          <b>State Counselling Authorities</b>
          <ul className="list-disc list-inside mt-2 pl-6 space-y-2">
            <p className="text-[16px]">
              <b>Managed by:</b> Respective State Government/UT Directorate of Medical Education
            </p>
            <p className="text-[16px]">
              <b>Seats Managed:</b>
            </p>

            <ul className="list-disc list-inside mt-2 pl-6 space-y-2">
              <li>85% State Quota seats in Government Medical and Dental Colleges</li>
              <li>
                100% seats in Private Medical and Dental Colleges in the state (except deemed universities)
              </li>
              <li>Management and NRI quota seats within that state</li>
            </ul>
            <p className="text-[16px]">
              <b>Key Points:</b>
            </p>
            <ul className="list-disc list-inside mt-2 pl-6 space-y-2">
              <li>Each state/UT releases its own merit list, counselling schedule, and eligibility criteria.</li>
              <li>Domicile rules, category reservations, and fee structures are as per state government norms.</li>
              <li>Admission to state and private colleges depends on the NEET AIR, but eligibility is decided by state authorities.</li>
            </ul>
          </ul>
        </li>
      </ol>
      <p className="mt-4 font-semibold text-[16px]">Important Highlights:</p>
      <ul className="list-disc list-inside mt-4 space-y-2 pl-6">
        <li>NTA’s role ends with conducting NEET UG and providing results. Counselling is handled entirely by MCC and State Counselling Authorities.</li>
        <li>Counselling will be online, and students must register separately with MCC and/or their state authority depending on their preferences.</li>
      </ul>

      <hr className="my-8 border-gray-500" />

      <h2 className="text-2xl font-semibold mt-8">NEET UG 2026 Counselling Process</h2>
      <p className="mt-4 text-[16px]">
        Once a candidate qualifies the NEET UG 2026 examination, the next critical phase is the counselling process, which facilitates the allocation of MBBS, BDS, BAMS, BHMS, BSMS, BUMS, and B.Sc. Nursing seats across medical institutions in India. This process is conducted in a centralized, merit-based, and online manner.
      </p>
      <ul className="list-inside mt-4 space-y-4">
        <li>
          <b>Step 1: Registration</b>
          <p className="mt-4 text-[16px]">The counselling process begins with online registration on the respective portal—either national or state, depending on the type of seat. During registration, the candidate must:</p>
          <ul className="list-disc list-inside mt-2 pl-6 space-y-2">
            <li>Use the NEET 2026 Roll Number and Application Number.</li>
            <li>Provide personal, academic, and contact information (as submitted during NEET application).</li>
            <li>Create a login ID and password for further access.</li>
          </ul>
        </li>
        <p className="mt-4 text-[16px]">This step is mandatory. Candidates failing to register will not be eligible for any further counselling activities.</p>
        <li>
          <b>Step 2: Payment of Fees</b>
          <p className="mt-4 text-[16px]">After registration, candidates must pay two types of counselling fees: </p>
          <ul className="list-disc list-inside mt-2 pl-6 space-y-2">
            <li>Non-refundable registration fee – applicable for processing and system access</li>
            <li>Refundable security deposit – returned if the candidate either joins the allotted college or does not receive a seat</li>
          </ul>


          <div className="overflow-x-auto w-full">
            <table className="border border-collapse mt-4 min-w-[600px]">
              <thead>
                <tr>
                  <th className="border px-4 py-2">Institution Type</th>
                  <th className="border px-4 py-2">Category</th>
                  <th className="border px-4 py-2">Registration Fee</th>
                  <th className="border px-4 py-2">Refundable Security Deposit</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="border px-4 py-2">AIQ / Central Universities / AIIMS / JIPMER</td>
                  <td className="border px-4 py-2">General</td>
                  <td className="border px-4 py-2">₹1,000</td>
                  <td className="border px-4 py-2">₹10,000</td>
                </tr>
                <tr>
                  <td className="border px-4 py-2">AIQ / Central Universities / AIIMS / JIPMER</td>
                  <td className="border px-4 py-2">SC/ST/OBC/PwBD</td>
                  <td className="border px-4 py-2">₹500</td>
                  <td className="border px-4 py-2">₹5,000</td>
                </tr>
                <tr>
                  <td className="border px-4 py-2">Deemed Universities (All categories)</td>
                  <td className="border px-4 py-2">All</td>
                  <td className="border px-4 py-2">₹5,000</td>
                  <td className="border px-4 py-2">₹2,00,000</td>
                </tr>
              </tbody>
            </table>
          </div>


          <p className="list-disc list-inside mt-4 space-y-2 text-[16px]">
            Candidates applying for both AIQ and Deemed University seats must pay the higher fee (₹2,05,000 in total). Payment must be made online via debit/credit card, net banking, or UPI.

          </p>
        </li>
        <li>
          <b> Step 3: Choice Filling and Locking</b>
          <p className="mt-4 text-[16px]">Upon successful payment, candidates may proceed to the choice filling phase.</p>
          <ul className="list-disc list-inside mt-2 pl-6 space-y-2">
            <li>Select colleges and courses (e.g., MBBS/BDS) from the available list.</li>
            <li>Arrange these choices in order of personal preference.</li>
            <li>Review and finalize the list before the locking deadline.</li>
          </ul>
          <p className="mt-4 text-[16px]">The number of choices is not limited, and candidates are advised to fill in a wide range to maximize their chances. Choices should be based on informed research, historical cut-offs, and personal preferences. Once finalized, candidates must lock their choices. If choices are not locked manually, the last saved preferences will be auto-locked after the deadline.</p>
          <p className="mt-4 text-[16px]">This step is critical, as the order of choices directly influences seat allotment.</p>
        </li>
        <li>
          <b>Step 4: Seat Allotment</b>
          <p className="mt-4 text-[16px]">Seat allotment is conducted by a central software system using the following criteria: </p>
          <ul className="list-disc list-inside mt-2 pl-6 space-y-2">
            <li>Candidate’s NEET All India Rank</li>
            <li>Category (UR, SC, ST, OBC, EWS, PwBD)</li>
            <li>Quota eligibility</li>
            <li>Preferences submitted during choice filling</li>
            <li>Seat availability in the participating institutions</li>
          </ul>
          <p className="mt-4 text-[16px]">The software matches these variables to allocate a seat in the best possible institution as per merit and availability.</p>
          <p className="mt-4 text-[16px]">After each round, allotment results are made available on the counselling portal. Candidates can download their Seat Allotment Letter, which includes the allotted college, course, category, and reporting schedule.</p>
        </li>
        <li>
          <b>Step 5: Reporting to the Allotted College</b>
          <ul className="my-2">
            <p className="my-4 text-[16px]">Candidates who are allotted a seat must report physically to the assigned college within the stipulated time. At the time of reporting, they must complete the document verification process and confirm admission by paying the college fee.</p>
            <li>
              <b>Documents required (Original + Photocopy):</b>
              <ul className="list-disc list-inside mt-2 pl-6 space-y-2">
                <li>NEET 2026 Admit Card and Scorecard</li>
                <li>Class 10 and 12 mark sheets and certificates</li>
                <li>Valid photo identification (Aadhaar, PAN card, etc.)</li>
                <li>Passport-size photographs (as used in NEET application)</li>
                <li>Caste, EWS, or PwBD certificate (if applicable)</li>
                <li>Seat Allotment Letter</li>
                <li>NRI/OCI documentation (if applicable for NRI quota)</li>
              </ul>
            </li>
            <p className="mt-4 text-[16px]">Failure to report within the designated timeframe or to produce the required documents will result in cancellation of the seat and forfeiture of the security deposit.</p>
          </ul>
        </li>
        <li>
          <b>Step 6: Participation in Subsequent Rounds</b>
          <p className="mt-4 text-[16px]">If the candidate is not satisfied with the allotted seat, or was not allotted any seat in the initial round, they may participate in subsequent rounds, including:</p>
          <ul className="list-disc list-inside mt-2 pl-6 space-y-2">
            <li><b>Round 2: </b>Candidates can opt for upgradation or fresh choices (if not allotted earlier).</li>
            <li><b>Mop-Up Round: </b>For vacant seats after Round 2 (mainly for central institutions and deemed universities).</li>
            <li><b>Stray Vacancy Round: </b> Final opportunity to fill remaining seats (especially in Deemed Universities; fresh registration is not permitted in AIQ).</li>
          </ul>
          <p className="mt-4 text-[16px]">
            <b>It is important to note:</b>
          </p>
          <ul className="list-disc list-inside mt-2 pl-6 space-y-2">
            <li>If a candidate accepts a seat in Round 2 and does not report, they are ineligible for further rounds.</li>
            <li>Candidates who resign after joining in Round 1 may still participate in Round 2, but only under specific conditions.</li>
          </ul>
        </li>
      </ul>

      <hr className="my-8 border-gray-500" />

      <h2 className="text-2xl font-semibold mt-8">NEET 2026 Counselling Schedule</h2>
      <p className="mt-4 text-[16px]">Below is the officially announced schedule for NEET UG 2026. All candidates are advised to keep track of these dates and complete each step within the specified timelines.</p>
      <div className=" py-4 flex flex-col items-center">
        <table className="border border-collapse mt-4">
          <thead>
            <tr>
              <th className="border px-4 py-2">Event</th>
              <th className="border px-4 py-2">Date &amp; Time</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="border px-4 py-2">Start of Online Application Submission</td>
              <td className="border px-4 py-2">07 February 2026</td>
            </tr>
            <tr>
              <td className="border px-4 py-2">Last Date for Online Application Submission</td>
              <td className="border px-4 py-2">07 March 2026 (up to 11:50 PM)</td>
            </tr>
            <tr>
              <td className="border px-4 py-2">Last Date for Fee Payment</td>
              <td className="border px-4 py-2">07 March 2026 (up to 11:50 PM)</td>
            </tr>
            <tr>
              <td className="border px-4 py-2">Correction Window for Application Form</td>
              <td className="border px-4 py-2">09 March 2026 to 11 March 2026</td>
            </tr>
            <tr>
              <td className="border px-4 py-2">Advance Intimation of Exam City</td>
              <td className="border px-4 py-2">By 26 April 2026</td>
            </tr>
            <tr>
              <td className="border px-4 py-2">Availability of Admit Card for Download</td>
              <td className="border px-4 py-2">By 01 May 2026</td>
            </tr>
            <tr>
              <td className="border px-4 py-2">NEET UG 2026 Exam Date</td>
              <td className="border px-4 py-2">04 May 2026 (Sunday)</td>
            </tr>
            <tr>
              <td className="border px-4 py-2">Examination Timing</td>
              <td className="border px-4 py-2">2:00 PM to 5:00 PM IST (Duration: 3 hours)</td>
            </tr>
            <tr>
              <td className="border px-4 py-2">Display of Answer Key and Recorded Responses</td>
              <td className="border px-4 py-2">To be notified later</td>
            </tr>
            <tr>
              <td className="border px-4 py-2">Declaration of Results (Tentative)</td>
              <td className="border px-4 py-2">By 14 June 2026</td>
            </tr>
          </tbody>
        </table>
      </div>

      <p className="mt-4 font-semibold">Notes:</p>
      <ul className="list-disc list-inside mt-4 pl-6 space-y-2">
        <li>All applicants should regularly visit the official NTA website <a href="https://www.nta.ac.in" target="_blank" rel="noopener noreferrer nofollow" className="text-blue-500 underline">www.nta.ac.in</a> or <a href="https://exams.nta.ac.in/NEET" target="_blank" rel="noopener noreferrer nofollow" className="text-blue-500 underline">https://exams.nta.ac.in/NEET</a> for updates or changes to the schedule.</li>
        <li>Deadlines are strict; late submissions or fee payments will not be accepted under any circumstances.</li>
        <li>The result date is tentative and may vary based on administrative considerations.</li>
      </ul>

      <hr className="my-8 border-gray-500" />

      <h2 className="text-2xl font-semibold mt-8">MCC Counselling 2026 – Comprehensive Explanation of Rules and Process</h2>
      <p className="mt-4 text-[16px]">
        The Medical Counselling Committee (MCC) conducts a centralized counselling process for admission to undergraduate medical and dental programs under the 15% All India Quota (AIQ), as well as for seats in AIIMS, JIPMER, ESIC, Central Universities, and Deemed Universities. The counselling is conducted online and is open to all candidates who qualify NEET UG 2026 and meet the eligibility requirements for these institutions.
      </p>
      <p className="mt-4 text-[16px]">
        The counselling process is organized in structured rounds and operates under strict procedural rules designed to ensure transparency, efficiency, and fairness in seat allocation.
      </p>
      <h3 className="text-xl font-semibold mt-8">Counselling Structure: Rounds Conducted by MCC</h3>
      <p className="text-[16px] mt-4">MCC counselling is conducted in four main rounds:</p>
      <ul className="list-disc list-inside mt-4 pl-6 space-y-2">
        <li>Round 1</li>
        <li>Round 2</li>
        <li>Mop-Up Round</li>
        <li>Stray Vacancy Round</li>
      </ul>
      <p className="mt-4 text-[16px]">
        Each round follows a specific protocol for registration, choice filling, seat allotment, reporting, and final admission. Candidates may participate in one or more rounds depending on their admission status and eligibility at each stage.
      </p>

      <h3 className="text-xl font-semibold mt-8">Exit Options and Their Implications</h3>
      <ol className="list-decimal list-inside mt-4 space-y-4">
        <li>
          <b>Free Exit in Round 1</b>
          <p className="mt-4 text-[16px]">As per the official counselling rules, if a candidate is allotted a seat in Round 1 but chooses not to join the allotted institution, the candidate is permitted to exit without any penalty. This is referred to as "Free Exit".</p>
          <ul className="list-disc list-inside mt-2 pl-6 space-y-2">
            <li>The candidate will not lose their security deposit.</li>
            <li>They remain fully eligible to participate in Round 2 and further rounds.</li>
            <li>No written resignation or application is required to avail this exit.</li>
          </ul>
        </li>
        <p className="mt-4 text-[16px]">This provision allows candidates to explore better opportunities in the upcoming rounds without financial or procedural repercussions.</p>
        <li>
          <b>Exit with Forfeiture in Round 2</b>
          <p className="mt-4 text-[16px]">In contrast to Round 1, the Exit with Forfeiture rule applies in Round 2. If a candidate is allotted a seat in Round 2 but fails to report or chooses not to join the allotted college:</p>
          <ul className="list-disc list-inside mt-2 pl-6 space-y-2">
            <li>The candidate will forfeit their refundable security deposit.</li>
            <li>The candidate becomes ineligible for further counselling rounds, including the Mop-Up and Stray Vacancy Rounds.</li>
            <li>This rule is enforced to ensure that seats are not wasted and to encourage commitment once Round 2 seats are allotted.</li>
          </ul>
        </li>
        <p className="mt-4 text-[16px]">Candidates are therefore advised to exercise caution while entering Round 2. Participation in this round should only be pursued if the candidate is genuinely willing to accept the allotment.</p>
      </ol>
      <h3 className="text-xl font-semibold mt-8">Security Deposit: Refund and Forfeiture Rules</h3>
      <ul className="list-disc list-inside mt-4 space-y-2">
        <p className="text-[16px]">At the time of registration for counselling, all candidates are required to pay:</p>
        <ul className="list-disc list-inside mt-2 pl-6 space-y-2">
          <li>A non-refundable registration fee</li>
          <li>A refundable security deposit</li>
        </ul>
        <p className="mt-4 text-[16px]">The refundable portion is returned to the candidate only under the following conditions:</p>
        <ul className="list-disc list-inside mt-2 pl-6 space-y-2">
          <li>The candidate is not allotted any seat during any of the rounds.</li>
          <li>The candidate is allotted a seat and joins the college by physically reporting and completing admission formalities.</li>
        </ul>
        <p className="mt-4 text-[16px]">
          However, if a candidate is allotted a seat and fails to join, or exits after Round 2, the security deposit is forfeited. No exceptions are made once the forfeiture condition is triggered.
        </p>
        <p className="mt-4 text-[16px]">
          The refund process is managed by MCC and is typically processed after the completion of all counselling rounds.
        </p>
      </ul>
      <h3 className="text-xl font-semibold mt-8">Resignation Policy After Round 2</h3>
      <p className="mt-4 text-[16px]">Once a candidate is allotted a seat in Round 2 and joins the institution by reporting and completing admission, the seat is considered as final and binding. According to MCC rules:</p>
      <ul className="list-disc list-inside mt-4 space-y-2 pl-6">
        <li>Once a candidate is allotted a seat in Round 2 and joins the institution by reporting and completing admission, the seat is considered as final and binding.</li>
        <li>No resignation is permitted after joining in Round 2.</li>
        <li>The candidate becomes ineligible to participate in any further rounds, including those conducted at the state level.</li>
        <li>The seat is locked, and no transfer to another institution is allowed.</li>
      </ul>
      <p className="mt-4 text-[16px]">This rule is implemented to ensure stability in seat occupancy and to prevent last-minute vacancies that cannot be filled during late stages of counselling.</p>
      <div>
        <h3 className="text-xl font-semibold mt-8">Implications for Candidates</h3>
        <ul className="list-disc list-inside mt-4 space-y-2 pl-6">
          <li>Use Round 1 as an opportunity to explore options without risking your security deposit.</li>
          <li>Be certain before participating in Round 2, as allotment leads to either mandatory admission or financial and procedural penalties.</li>
          <li>Understand that once you join a college in Round 2, you cannot resign or seek reallocation in any other counselling (including state-level or institutional counselling).</li>
          <li>Ensure full document readiness before reporting, as failure to produce valid originals may result in cancellation of the seat.</li>
        </ul>

        <hr className="my-8 border-gray-500" />

        <h2 className="text-2xl font-semibold mt-8">Documents Required for MBBS Counselling 2026</h2>
        <ol className="list-decimal list-inside mt-4 space-y-2">
          <li>NEET Allotment Letter</li>
          <li>NEET Admit Card</li>
          <li>NEET Scorecard / Rank Letter</li>
          <li>Class 10th Certificate</li>
          <li>Class 12th Certificate</li>
          <li>Class 12th Marksheet</li>
          <li>Passport Size Photographs (8–12 copies)</li>
          <li>Photo Identity Proof (Aadhar / PAN / Passport / DL)</li>
          <li>Medical Fitness Certificate</li>
          <li>Migration Certificate</li>
          <li>Transfer Certificate (TC)</li>
          <li>Character Certificate</li>
          <li>Nationality Certificate or Indian Passport</li>
          <li>Choice Filling Slip (from MCC/State Portal)</li>
          <li>Scanned Signature</li>
          <li>Gap Affidavit (if applicable)</li>
          <li>Caste Certificate (SC/ST/OBC)</li>
          <li>Caste Validity Certificate (if applicable)</li>
          <li>EWS Certificate (if applicable)</li>
          <li>Non-Creamy Layer Certificate (for OBC)</li>
          <li>PwD Certificate (if applicable)</li>
          <li>Minority Certificate (if applicable)</li>
          <li>Domicile Certificate (if required)</li>
          <li>OCI Card (if applicable)</li>
        </ol>

        <hr className="my-12 border-gray-400" />

        <h2 className="text-2xl font-semibold mt-8">MBBS Seat Reservation in NEET UG 2026</h2>
        <h3 className="text-xl font-semibold mt-8">1. Reservation Policy under the 15% All India Quota (AIQ)</h3>
        <p className="mt-4 text-[16px]">
          The All India Quota (AIQ) comprises 15% of the total available seats in government medical and dental colleges (excluding institutions like AIIMS and JIPMER). The reservation under this quota is governed by central government norms.
        </p>
        <p className="font-semibold mt-4 text-[16px]">Applicable reservation under AIQ:</p>
        <ul className="list-disc list-inside mt-4 space-y-2 pl-6">
          <li>Scheduled Castes (SC): 15%</li>
          <li>Scheduled Tribes (ST): 7.5%</li>
          <li>Other Backward Classes – Non-Creamy Layer (OBC-NCL – Central List only): 27%</li>
          <li>Economically Weaker Sections (EWS): 10%</li>
          <li>Persons with Benchmark Disabilities (PwBD): 5% (horizontal across categories)</li>
        </ul>
        <p className="font-semibold mt-4 text-[16px]">Important notes:</p>
        <ul className="list-disc list-inside mt-4 space-y-2 pl-6">
          <li>OBC reservation is only for candidates listed in the Central OBC List</li>
          <li>PwBD reservation is applied across all categories horizontally.</li>
        </ul>

        <h3 className="text-xl font-semibold mt-8">2. Reservation for Persons with Benchmark Disabilities (PwBD)</h3>
        <p className="mt-4 text-[16px]">As per the Rights of Persons with Disabilities Act, 2016 and NMC regulations, PwBD candidates are eligible for horizontal reservation.</p>
        <p className="font-semibold mt-4 text-[16px]">Eligibility and conditions:</p>
        <ul className="list-disc list-inside mt-4 space-y-2 pl-6">
          <li>5% horizontal reservation across all categories (GEN, SC, ST, OBC-NCL, EWS).</li>
          <li>Candidate must hold a valid PwBD certificate from a designated medical board.</li>
          <li>Disability must conform to eligibility criteria as per Graduate Medical Education Regulations, 1997 (amended 2019).</li>
          <li>Candidate must fulfill all other NEET eligibility norms for admission.</li>
        </ul>

        <h3 className="text-xl font-semibold mt-8">3. Reservation in Central Institutions and Deemed Universities</h3>
        <p className="pt-4 text-[16px]">Institutions like AIIMS, JIPMER, and Central Universities (DU, BHU, AMU), ESIC Medical Colleges, and Deemed Universities follow central reservation guidelines.
        </p>
        <ul className="list-disc list-inside my-4 space-y-2 pl-6">
          <li>SC: 15%</li>
          <li>ST: 7.5%</li>
          <li>OBC-NCL: 27% (Central List only)</li>
          <li>EWS: 10%</li>
          <li>PwBD: 5% (horizontal)</li>
        </ul>
        <p className="font-semibold text-[16px]">Additional remarks:</p>
        <ul className="list-disc list-inside mt-4 space-y-2 pl-6">
          <li>Some institutions may apply additional internal or domicile-based quotas (e.g., Puducherry quota in JIPMER).</li>
          <li>Reservation is implemented as per each institution’s founding Act or Ministry regulations.</li>
        </ul>

        <h3 className="text-xl font-semibold mt-8 pb-4">4. Reservation in State Quota and Private Medical Colleges</h3>
        <p className=" text-[16px]">For 85% of the seats under the State Government Quota and for private institutions, reservation policies are framed by respective State or UT governments.</p>
        <p className="font-semibold mt-2">Key details:</p>
        <ul className="list-disc list-inside pt-2 space-y-2 pl-6">
          <li>Each state applies its own reservation rules for SC, ST, OBC, EWS, PwBD, etc.</li>
          <li>May include local quotas such as:
            <ul className="list-disc list-inside mt-2 pl-6 space-y-2">
              <li>Domicile/residence-based reservations</li>
              <li>Reservation for female candidates</li>
              <li>Minority and backward class quotas</li>
            </ul>
          </li>
          <li>Private institutions follow state norms for management/NRI quota allocation.</li>
          <li>Central reservation norms do not apply to State Quota or private medical colleges.</li>
        </ul>

        <h3 className="text-xl font-semibold mt-8 pb-2">5. Central Pool Quota (CPQ)</h3>
        <p className=" text-[16px]">The Central Pool Quota is reserved for candidates from specific categories and underserved regions.</p>
        <p className="font-semibold pt-2 text-[16px]">Eligibility under CPQ:</p>
        <ul className="list-disc list-inside py-2 space-y-2 pl-6">
          <li>Wards of civilians affected by terrorism.</li>
          <li>Children of deceased or disabled defence personnel.</li>
          <li>Students from states/UTs with inadequate or no medical colleges (e.g., some North Eastern states).</li>
        </ul>
        <p className="font-semibold text-[16px]">Other Details: </p>
        <ul className="list-disc list-inside mt- pt-2 pl-6 space-y-2">
          <li>CPQ is managed by the Ministry of Health and Family Welfare.</li>
          <li>Admissions are based on NEET merit and subject to CPQ eligibility rules.</li>
        </ul>

        <h3 className="text-xl font-semibold mt-8">6. Women-Specific Medical College</h3>
        <p className="font-semibold pt-2 text-[16px]">Colleges exclusively for girls:</p>
        <ul className="list-disc list-inside mt-2 space-y-2 pl-6">
          <li>Lady Hardinge Medical College, New Delhi</li>
          <li>BPS Government Medical College, Khanpur Kalan, Sonepat, Haryana</li>
          <li>Symbiosis Medical College for Women, Pune, Maharashtra</li>
        </ul>
        <p className="font-semibold text-[16px] mt-4">Points to note:</p>
        <ul className="list-disc list-inside mt-2 space-y-2 pl-6">
          <li>Admission is done through NEET-UG.</li>
          <li>Only female candidates are eligible to apply.</li>
          <li>These institutions follow standard NEET eligibility and counselling process.</li>
        </ul>

        <hr className="my-8 border-gray-500" />

        <h2 className="text-2xl font-semibold mt-8">STATE-WISE MBBS COUNSELLING 2026</h2>
        <h3 className="text-xl font-semibold mt-8">1. Who Conducts State Counselling?</h3>
        <ul className="list-disc list-inside mt-4 space-y-2 pl-6">
          <li>Every state and Union Territory (UT) has a designated counselling authority (typically the Directorate of Medical Education).</li>
          <li>These authorities conduct counselling for:
            <ul className="list-disc list-inside mt-2 pl-6 space-y-2">
              <li>85% State Quota seats in Government Medical and Dental Colleges.</li>
              <li>100% seats in Private Medical and Dental Colleges, including Management Quota and NRI Quota seats.</li>
            </ul>
          </li>
        </ul>

        <h3 className="text-xl font-semibold mt-8">2. Seats Covered Under State Counselling</h3>
        <ul className="list-disc list-inside mt-4 space-y-2 pl-6">
          <li>
            <b>Government Medical/Dental Colleges:</b>
            <ul className="list-disc list-inside mt-2 pl-6 space-y-2">
              <li>Only 85% of the seats are filled through state counselling.</li>
              <li>The remaining 15% are filled under the All India Quota (AIQ) by MCC.</li>
            </ul>
          </li>
          <li>
            <b>Private Medical Colleges/Deemed Universities:</b>
            <ul className="list-disc list-inside mt-2 pl-6 space-y-2">
              <li>100% of seats including General, Management, and NRI quota are filled by state counselling authorities.</li>
            </ul>
          </li>
        </ul>

        <h3 className="text-xl font-semibold mt-8">3. Domicile and Eligibility Requirements</h3>
        <ul className="list-disc list-inside mt-4 space-y-2 pl-6">
          <li>States impose domicile rules, which vary by state.</li>
          <li>Domicile status may be based on:
            <ul className="list-disc list-inside mt-2 pl-6 space-y-2">
              <li>Place of birth</li>
              <li>Years of study in the state</li>
              <li>Parent’s residency status</li>
            </ul>
          </li>
          <li>Some states allow non-domicile candidates to apply under Management or NRI quota only.</li>
        </ul>

        <h3 className="text-xl font-semibold mt-8">4. State Counselling Process: Step-by-Step</h3>
        <ol className="list-decimal list-inside mt-4 space-y-4">
          <p className=" text-[16px]">Each state follows a broadly similar process with independent timelines and websites. Here's the general sequence:</p>
          <div className="mt-4">
            <b>Step 1: Online Registration</b>
            <ul className="list-disc list-inside mt-2 pl-6 space-y-2">
              <li>Candidates must register on the official website of the respective state counselling authority.</li>
              <li>Details such as NEET Roll Number, AIR (All India Rank), Personal & Academic Info are required.</li>
              <li>Payment of registration/counselling fee is mandatory. Fees may vary for government and private seat aspirants.</li>
            </ul>
          </div>
          <div className="mt-4">
            <b>Step 2: Upload and Verification of Documents</b>
            <ul className="list-disc list-inside mt-2 pl-6 space-y-2">
              <li>Candidates are asked to upload scanned copies of:
                <ul className="list-disc list-inside mt-2 pl-6 space-y-2">
                  <li>NEET 2026 Admit Card</li>
                  <li>NEET 2026 Scorecard</li>
                  <li>Class 10 and 12 Mark Sheets</li>
                  <li>Birth Certificate or School Certificate for DOB proof</li>
                  <li>Caste/Category Certificate (if applicable)</li>
                  <li>Domicile Certificate (if required by the state)</li>
                  <li>PwBD Certificate (if applicable)</li>
                </ul>
              </li>
              <li>Some states conduct offline document verification at designated centers.</li>
            </ul>
          </div>
          <div className="mt-4">
            <b>Step 3: Publication of State Merit List</b>
            <ul className="list-disc list-inside mt-2 pl-6 space-y-2">
              <li>After document verification, the state releases a merit list.</li>
              <li>This merit list includes:
                <ul className="list-disc list-inside mt-2 pl-6 space-y-2">
                  <li>Candidate's Name</li>
                  <li>NEET Score and Rank</li>
                  <li>State Rank</li>
                  <li>Category (General/OBC/SC/ST/EWS)</li>
                </ul>
              </li>
              <li>Only candidates in the merit list are eligible for choice filling and seat allotment.</li>
            </ul>
          </div>
          <div className="mt-4">
            <b>Step 4: Choice Filling and Locking</b>
            <ul className="list-disc list-inside mt-2 pl-6 space-y-2">
              <li>Candidates log in and select their preferred colleges and courses.</li>
              <li>Options must be arranged in order of preference.</li>
              <li>Once choices are locked, no changes are allowed.</li>
            </ul>
          </div>
          <div className="mt-4">
            <b>Step 5: Seat Allotment</b>
            <ul className="list-disc list-inside mt-2 pl-6 space-y-2">
              <li>Based on:
                <ul className="list-disc list-inside mt-2 pl-6 space-y-2">
                  <li>NEET Rank</li>
                  <li>Category</li>
                  <li>Preferences</li>
                  <li>Seat availability</li>
                </ul>
              </li>
              <li>A seat allotment list is released with college and course assigned to each candidate.</li>
            </ul>
          </div>
          <div className="mt-4">
            <b>Step 6: Download Allotment Letter and Reporting</b>
            <ul className="list-disc list-inside mt-2 pl-6 space-y-2">
              <li>Candidates must download their Provisional Allotment Letter.</li>
              <li>Visit the allotted college within the stipulated time.</li>
              <li>Complete admission formalities:
                <ul className="list-disc list-inside mt-2 pl-6 space-y-2">
                  <li>Submit original documents</li>
                  <li>Pay college fees</li>
                  <li>Confirm admission</li>
                </ul>
              </li>
            </ul>
          </div>
        </ol>

        <h3 className="text-xl font-semibold mt-8">5. Mop-Up Round (Post Round 2)</h3>
        <ul className="list-disc list-inside mt-4 space-y-2 pl-6">
          <li>Conducted by State Authorities to fill vacant seats left after Round 1 and 2.</li>
          <li>Only those candidates who:
            <ul className="list-disc list-inside mt-2 pl-6 space-y-2">
              <li>Didn’t get a seat in previous rounds</li>
              <li>Didn’t take admission</li>
              <li>Withdraw from earlier allotted seats are eligible.</li>
            </ul>
          </li>
          <li>Fresh registration may be required.</li>
        </ul>

        <h3 className="text-xl font-semibold mt-8">6. Stray Vacancy Round</h3>
        <ul className="list-disc list-inside mt-4 space-y-2 pl-6">
          <li>For residual vacant seats.</li>
          <li>Mostly filled through manual/spot counselling at the college level.</li>
          <li>Conducted under state authority supervision.</li>
          <li>No fresh choice filling—candidates must report directly to colleges.</li>
        </ul>

        <h3 className="text-xl font-semibold mt-8">7. Points to Remember</h3>
        <ul className="list-disc list-inside mt-4 space-y-2 pl-6">
          <li>
            Candidates can participate in both All India (MCC) and State
            counselling simultaneously, but once admitted in a round, certain
            rules may restrict further participation.
          </li>
          <li>
            Candidates must follow the reservation policies and eligibility
            norms of the particular state.
          </li>
          <li>
            All updates, notifications, and dates must be tracked via the
            official websites of the respective state counselling authorities.
          </li>
        </ul>


        <section className="w-full max-w-7xl mx-auto mt-14 mb-16 sm:mb-0">
          <h2
            className="sm:text-3xl text-2xl font-bold text-center capitalize"
            style={{ color: "#140342", fontSize: "28.125px" }}
          >
            Frequently asked <span className="text-[#ff9245]">questions</span>
          </h2>
          <div className="mt-8 space-y-4 ml-6 mr-6">
            {faqData.map((faq, index) => (
              <div
                key={index}
                className={`p-4 border rounded-lg shadow-md ${activeFAQ === index ? "bg-gray-50" : ""
                  }`}
                onClick={() => toggleFAQ(index)}
              >
                <div className="flex justify-between items-center cursor-pointer">
                  <h3
                    className="text-lg font-semibold"
                    style={{ color: "#140342", fontSize: "16.875px" }}
                  >
                    {faq.question}
                  </h3>
                  <span>{activeFAQ === index ? "-" : "+"}</span>
                </div>
                <div
                  className={`mt-2 text-gray-600 text-left text-lg ${activeFAQ === index ? "block" : "hidden"
                    }`}
                >
                  {faq.answer}
                </div>
              </div>
            ))}
          </div>
        </section>
      </div>
    </div>
  );
};
export default NeetCounsellingContent;
